import {
	Component,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Task } from "@app/definitions/types"
import * as moment from "moment"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, TableWrapComponent } from "@app/utils/utils.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { TimeFormatPipe } from "@app/utils/time-format.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GenTableAddItemComponent } from "@app/gen-table-add-item/gen-table-add-item.component"

@Component({
	selector: "app-sub-user-payments",
	imports: [
		COMMON_IMPORTS,
		GenSelectComponent,
		LangValPipe,
		TableWrapComponent,
		DateFormatPipe,
		GenInputComponent,
		BtnExtComponent,
		GenAutocompleteComponent,
		DatePickerComponent,
		TimeFormatPipe,
		ModalWrapComponent,
		GenTableAddItemComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./sub-user-payments.component.html",
})
export class SubUserPaymentsComponent extends Modalable {
	modalProps: any = null
	years: any[] = [] //the options for years to choose from
	months: any[] = []
	year: number = new Date().getFullYear()
	month: number = 1
	rows: any[] = []
	task = new Task() //the object that holds the field values (and is saved)
	monthErr: any = {}
	@ViewChild("expensetypeFuzzyInput")
	expensetypeFuzzyInput: GenAutocompleteComponent

	ngOnInit() {
		//when called to open
		const thisYear = new Date().getFullYear()
		for (let i = 2021; i <= thisYear; i++) {
			this.years.push({ id: i, name: i })
		}
		for (let i = 1; i <= 12; i++) {
			this.months.push({ id: i, name: i })
		}
		this.rows = []
		const lastDayOfLastMonth = moment.utc().subtract(1, "month").endOf("month")
		this.year = lastDayOfLastMonth.year()
		this.month = lastDayOfLastMonth.month() + 1
		this.loadData()
	}
	async loadData() {
		this.monthErr = {}
		const lastDayOfLastMonth = moment.utc().subtract(1, "month").endOf("month")
		const firstDayOFSearchMonth = moment
			.utc()
			.month(this.month - 1)
			.year(this.year)
			.startOf("month")
		const isInPast = firstDayOFSearchMonth.isBefore(lastDayOfLastMonth)
		if (!isInPast) {
			this.monthErr = { month: this.lang.getVal("month_in_future") }
			return
		}

		const res: any = await this.apiService.post(
			"get_sub_user_payments",
			this,
			"month,year"
		)
		this.rows = res.rows
		this.rows.forEach((row) => {
			row.userName =
				this.store.searchSiteDataItem(row.user_id, ["sub_users"])?.name || ""
			row.sumFormValid = false
			row.expenseFormValid = false
			row.followupsOpen = false
			row.savedSum = row.sum
			if (row.followups) {
				row.followups.forEach((followup) => {
					followup.patient_name = ""
					if (followup.patient_id) {
						followup.patient_name =
							this.store.searchSiteDataItem(followup.patient_id, ["patients"])
								?.name || ""
					}
				})
			} else {
				row.followups = []
			}
			row.errors = {}
			if (!row.expensetype_id && row.last_expensetype_id) {
				row.expensetype_id = row.last_expensetype_id
				row.expensetype_name =
					this.store.searchSiteDataItem(row.last_expensetype_id, [
						"expensetypes",
					])?.name || ""
			}
			this.loadExpenseRow(row)
			// row.to_be_paid = this.getUserMonthlyToBePaid(row.user_id);
		})
	}

	changeSum(row: any) {
		if (!row.errors) {
			row.errors = {}
		}
		row.errors.sum = null
		this.validator.validateField(row, row.errors, "sum", { is_positive: null })
		row.sumFormValid = true
		if (row.errors.sum) {
			row.sumFormValid = false
		}
	}
	changeExpenseForm(row: any) {
		row.expensetype_str = ""
		if (!row.errors) {
			row.errors = {}
		}
		row.expenseFormValid = true
		const fields = ["supplier_invoice", "expensetype_id", "expense_sum", "date"]
		fields.forEach((field) => {
			if (!row[field]) {
				row[field] = field == "expensetype_id" ? 0 : ""
			}
			row.errors[field] = null
			const validationObj =
				field == "expensetype_id"
					? { is_legit_fuzzy_value: true }
					: { not_empty: null }
			this.validator.validateField(row, row.errors, field, validationObj)
			if (row.errors[field]) {
				row.expenseFormValid = false
			}
		})
	}
	async submitSum(row: any) {
		row.sumFormValid = false
		if (row.sum) {
			row.sumSaving = true
			const res: any = await this.apiService.post(
				"sub_user_payments_update_sum",
				row,
				"id,sum"
			)
			row.sumSaving = false
			this.modalService.openToast("saved_successfully")
			row.savedSum = row.sum
		}
	}
	async submitExpenseForm(row: any) {
		row.expenseFormValid = false
		row.expenseSaving = true

		const res: any = await this.apiService.post(
			"sub_user_payments_create_expense",
			row
		)
		row.expenseSaving = false
		this.modalService.openToast("saved_successfully")
		row.expense_id = res.id
		this.loadExpenseRow(row, res)
		this.store.addGenItemRow("expenses", res)
		//add to site data?
	}
	loadExpenseRow(row: any, expense: any = null) {
		if (!row.expense_id) {
			return
		}
		if (!expense) {
			expense = this.store.searchSiteDataItem(row.expense_id, ["expenses"])
		}
		row.expense = { ...expense }
		row.expensetype = ""
		if (row.expense && row?.expense.expensetype_id) {
			row.expensetype =
				this.store.searchSiteDataItem(row.expense.expensetype_id, [
					"expensetypes",
				])?.name || ""
		}
	}

	openAddExpensetypeModal(row: any) {
		this.modalProps = { name: "add-expensetype", row }
	}
	handleAddExpesetypeClose(obj: any) {
		const { row } = this.modalProps
		this.modalProps = null
		if (!obj) {
			return
		}
		row.expensetype_name = obj.name
		row.expensetype_id = obj.id
		this.changeExpenseForm(row)
	}
}
